import React from 'react';

function ReferrerPendingVerification() {
	return (
		<div className="container mt-5">
			<div className="row justify-content-center">
				<div className="col-md-8 text-center">
					<h3>Account Pending Verification</h3>
					<p className="mt-3">
						Your account is currently being reviewed by our admin team.
						You will receive an email once your account has been verified.
					</p>
					<p className="text-muted">
						Once verified, you will be able to view authorized patient information
						for patients who have signed a Release of Information naming you.
					</p>
				</div>
			</div>
		</div>
	);
}

export default ReferrerPendingVerification;
